module.exports = __webpack_public_path__ + "static/media/surf_puerto.84666b44.jpg";